
import { defineComponent, ref, watch } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import Loading from "vue-loading-overlay";
import { Modal } from "bootstrap";
import AddFeaturesModal from "@/components/modals/forms/AddFeaturesModal.vue";
import { BILLED, PRICE_TYPE } from "../enum";
import { MasterPricing } from "../model/MasterPricing";
import { useToast } from "vue-toastification";
import ApiService from "@/core/services/ApiService";
import { useRouter } from "vue-router";
import DayMonthPicker from "@/components/widgets/custom/DayMonthPicker.vue";

export default defineComponent({
  name: "Add Feature",
  components: {
    Field,
    Form,
    AddFeaturesModal,
    ErrorMessage,
    Loading,
    DayMonthPicker,
  },
  setup() {
    const isLoading = ref(false);
    const fullPage = ref(false);
    const isColor = "#007BFF";
    const isBackgroundColor = "#A3A3A3";
    const isOpacity = 0.5;
    const toast = useToast();
    const userStorage = ref(localStorage.getItem("user_account"));
    const currentUser = ref();
    const features = ref([] as any);
    const dataPricing = ref<MasterPricing>({
      price_title: "",
      description: "",
      price_type: "",
      price: 0,
      tax: 0,
      features: [],
      billing_setting: {
        billed: "monthly",
        billing_day: "0",
      },
      is_active: true,
    } as unknown as MasterPricing);

    const router = useRouter();

    const priceTypeEnum = ref(PRICE_TYPE);
    const priceType = [
      priceTypeEnum.value.FREE,
      priceTypeEnum.value.FIXED,
      priceTypeEnum.value.RECURRING,
    ];

    const billedTypeEnum = ref(BILLED);
    const billedType = [
      {
        key: billedTypeEnum.value.MONTH.toLowerCase(),
        value: billedTypeEnum.value.MONTH,
      },
      {
        key: billedTypeEnum.value.DAY.toLowerCase(),
        value: billedTypeEnum.value.DAY,
      },
      {
        key: billedTypeEnum.value.YEAR.toLowerCase(),
        value: billedTypeEnum.value.YEAR,
      },
    ];

    if (userStorage.value) {
      currentUser.value = JSON.parse(userStorage.value);
    }
    console.log(currentUser.value);

    const handleSubmit = () => {
      isLoading.value = true;
      dataPricing.value.features = features.value;
      console.log(dataPricing.value);

      ApiService.postWithData(
        "crmv2/main_feature/pricing-plans",
        dataPricing.value
      )
        .then((res) => {
          console.log(res);
          toast.success("Data berhasil disimpan");
        })
        .catch((e) => {
          console.log(e);

          if (e.response.status == 401) {
            toast.error(e.response.data.detail);
            router.push("/sign-in");
            isLoading.value = false;
          } else {
            toast.error(e.response.data.detail);
            isLoading.value = false;
          }
        })
        .finally(() => {
          isLoading.value = false;
          router.push("/superadmin/master-feature/pricing");
        });
    };

    const handleAddFeature = (data) => {
      console.log("data dari add modal", data);

      features.value = data;
    };

    const removeModule = (index) => {
      features.value.splice(index, 1);
    };
    const formatPrice = (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    watch(
      dataPricing.value,
      (newValue) => {
        if (
          dataPricing.value.price_type ===
          priceTypeEnum.value.FREE.toLowerCase()
        ) {
          dataPricing.value.billing_setting.billed = "";
          dataPricing.value.billing_setting.billing_day = "0";
          dataPricing.value.billing_setting.billing_due_day = 0;
          dataPricing.value.price = 0;
          dataPricing.value.tax = 0;
        } else if (
          dataPricing.value.price_type ===
          priceTypeEnum.value.FIXED.toLowerCase()
        ) {
          dataPricing.value.billing_setting.billed = "";
          dataPricing.value.billing_setting.billing_day = "0";
          dataPricing.value.billing_setting.billing_due_day = 0;
        }
      },
      { immediate: true }
    );

    watch(dataPricing.value.billing_setting, (newVal) => {
      if (
        dataPricing.value.billing_setting.billed ===
        billedTypeEnum.value.DAY.toLowerCase()
      ) {
        if (parseInt(dataPricing.value.billing_setting.billing_day) > 31) {
          toast.error("data tidak boleh lebih dari 31");
          dataPricing.value.billing_setting.billing_day = "31";
        }
      }
      if (
        dataPricing.value.billing_setting.billed ===
        billedTypeEnum.value.MONTH.toLowerCase()
      ) {
        if (parseInt(dataPricing.value.billing_setting.billing_day) > 12) {
          toast.error("data tidak boleh lebih dari 12");
          dataPricing.value.billing_setting.billing_day = "12";
        }
      }
    });

    const isRequired = (value) => {
      if (!value) {
        return "Field ini wajib diisi";
      }
      return true;
    };


    const items = ref([
      { id: 1, name: "User Management" },
      { id: 2, name: "Analytics Dashboard" },
    ]);

    return {
      isLoading,
      fullPage,
      isColor,
      isBackgroundColor,
      isOpacity,
      items,
      priceType,
      dataPricing,
      priceTypeEnum,
      billedTypeEnum,
      billedType,
      features,
      removeModule,
      formatPrice,
      handleAddFeature,
      handleSubmit,
      isRequired,
    };
  },
});
